import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { QuerySaveService } from '../query-save-service';
import { FtoProApi } from '../../apis/fto-pro-api';
import { CurrentTaskService } from '@/services/current-task/current-task-service';

/**
 * 查询保存服务实现
 * @description 保存用户自定义查询语句，使用FtoProApi的customSearch方法
 */
@injectable()
export class QuerySaveServiceImpl implements QuerySaveService {
    constructor(
        @inject(FtoProApi)
        private readonly _ftoProApi: FtoProApi,
        @inject(CurrentTaskService)
        private readonly _currentTaskService: CurrentTaskService,
    ) {}

    /**
     * 保存用户自定义查询语句
     * @param query - 用户输入的查询语句
     * @param searchIndex - 搜索索引
     * @returns 保存是否成功
     */
    async saveQuery(query: string, searchIndex: number): Promise<boolean> {
        try {
            // 调用customSearch API保存查询语句
            await this._ftoProApi.customSearch({
                task_id: this._currentTaskService.taskId,
                search_index: searchIndex,
                query,
            });
            return true;
        } catch (error) {
            console.error('Failed to save query:', error);
            return false;
        }
    }
}
